import { TFilters } from '@/core/types'
import { toValue } from 'vue'
import { TInvitationStatistics } from './types'
import api from '@/core/config/axios'
import { createCatalogEndpoint } from '@/core/utils'
import { TSeller } from '../invitations'

export const serviceConfig = {
  invitations: {
    model: 'invitations-statistics',
    version: 'v1',
  },
  sellers: {
    model: 'sellers',
    version: 'v1',
  },
}
const { invitations, sellers } = serviceConfig

const sellersCatalog = createCatalogEndpoint<TSeller[]>(
  sellers.model,
  sellers.version,
)

const moduleServiceHandlers = {
  loadInvitationStatistics: async (
    params: TFilters,
  ): Promise<TInvitationStatistics> =>
    api
      .get(
        `${invitations.version}/${invitations.model}?${toValue(
          params.dynamicFilters ?? '',
        )}`,
      )
      .then((response) => response.data),
}

const catalogServiceHandlers = {
  sellersCatalog,
}

export { moduleServiceHandlers, catalogServiceHandlers }
